"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createCookie = exports.accessCookie = void 0;
var _constants = require("./constants");
var accessCookie = function accessCookie(cookieName) {
  var name = "".concat(cookieName, "=");
  var allCookieArray = document.cookie.split(';');
  for (var i = 0; i < allCookieArray.length; i++) {
    var trimmedCookie = allCookieArray[i].trim();
    if (trimmedCookie.indexOf(name) === 0) {
      return trimmedCookie.substring(name.length, trimmedCookie.length);
    }
  }
};
exports.accessCookie = accessCookie;
var createCookie = function createCookie(_ref) {
  var name = _ref.name,
    value = _ref.value,
    _ref$expires = _ref.expires,
    expires = _ref$expires === void 0 ? 60 * 60 * 1000 : _ref$expires,
    _ref$path = _ref.path,
    path = _ref$path === void 0 ? '/' : _ref$path;
  var date = new Date();
  date.setTime(date.getTime() + expires * 60 * 60 * 1000);
  var mainDomain;
  try {
    if (process.env.REACT_APP_ENVIRONMENT !== _constants.AppEnvironment.Production) {
      mainDomain = window.location.hostname;
    } else {
      // In prod environment, set cookie across subdomains as well
      // (e.g. joinmonument.com and also app.joinmonument.com)
      mainDomain = new URL(_constants.MARKETING_SITE_URL).hostname;
    }
  } catch (e) {
    mainDomain = window.location.hostname;
  }
  document.cookie = "".concat(name, "=").concat(encodeURIComponent(value), "; domain=").concat(mainDomain, "; path=").concat(path, "; expires=").concat(date.toGMTString(), ";");
};
exports.createCookie = createCookie;